import { getIn, useFormikContext } from 'formik';
import { useEffect } from 'react';
export function TitleChangeHandler({ titleFieldKey = 'title', genderFieldKey = 'gender', titles, genders, }) {
    const { values, setFieldValue } = useFormikContext();
    const titleValue = getIn(values, titleFieldKey);
    useEffect(() => {
        if (!titleValue) {
            return;
        }
        const selectedTitle = titles.find(title => String(title.id) === titleValue);
        const selectedGender = genders.find(gender => String(gender.id) === (selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.idGender));
        if (selectedGender) {
            setFieldValue(genderFieldKey, selectedGender.peopleCode);
        }
    }, [titleValue]);
    return null;
}
